/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';
const trackingUtils = require('od-modules/utils/tracking.utils');
const loginMenu = require('od-modules/helpers/login_menu');

module.exports = Odigeo.View.extend({
    events: {
        'tap @closeBtn': 'closeLightBox',
        'tap': 'onTapOutsidePopup',
        'tap @benefitsArea': 'trackGreenBannerClickEvent',
    },

    selectors: {
        loginFeedbackPopup: '.membership_login_feedback',
        closeBtn: '.close_popup',
        benefitsArea: '.membership_login_feedback_benefits',
    },

    renderLoginFeedback: function(userName) {
        if (Odigeo.Utils.isDesktop() && loginMenu.isPageWithOf2Login()) {
            this.setTemplate(this.$el, 'membershipLoginFeedbackOf2', this.widget.options);
        } else {
            this.keys = Odigeo._.extend(this.keys, {
                'primeLoginFeedbackTitle': Odigeo.Utils.replaceCmsKeyArgs(this.keys.primeLoginFeedbackTitle, userName),
            });
            this.setTemplate(this.$el, 'membershipLoginFeedback', this.widget.options);
            this.openLightBox();
        }
    },

    openLightBox: function() {
        this.trackEvent('onload_msg');
        this.$cachedSelectors.loginFeedbackPopup.addClass('open');
    },

    closeLightBox: function() {
        this.trackEvent('close_msg');
        this.$cachedSelectors.loginFeedbackPopup.removeClass('open');
    },

    onTapOutsidePopup: function(e) {
        if (0 === $(e.target).closest('.feedback_prevent_close_on_tap').length) {
            this.closeLightBox();
        }
    },

    trackGreenBannerClickEvent: function() {
        this.trackEvent('click_msg');
    },

    trackEvent: function(label) {
        const category = Odigeo.History.getPageNameFromFragment();
        const action = 'prime_welcome_popup';
        const messageShownToTheUser = 'hotel : hotel benefits';
        const returnedLabel = `${action}_${label}:${messageShownToTheUser}`;
        trackingUtils.trackEventWithCategory(category, action, returnedLabel);
    },
});
